import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterLang'
})
export class FilterLangPipe implements PipeTransform {

  transform(values: any[], filter: string, lang: string, property: string): any[] {
    if (!values) {
      return [];
    }
    if (!filter) {
      return values;
    }
    return values.filter(x => x[property]?.[lang]?.toLowerCase().includes(filter?.toLowerCase()));
  }

}
